import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { OnOffSwitch, OnOffSwitchSize } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { quotaKeys } from "../../utils/i18n";

type Props = {
    isSelected: boolean;
    onClick: VoidFunction;
};

const ExportCostToggle = ({ isSelected, onClick }: Props) => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="8px"
            alignItems="center"
        >
            <OnOffSwitch
                isSelected={isSelected}
                size={OnOffSwitchSize.small}
                onClick={onClick}
            />

            <Text
                fontVariant="captionTitle"
                color={colorsPalettes.carbon[300]}
            >
                {translate(quotaKeys.toggleExportCost)}
            </Text>
        </Flex>
    );
};

export default ExportCostToggle;
